<h1>This is secure content</h1>
<p>You must login to view this page</p>
<div>
  <img src="/congrats-animation-starter-kit.gif" width="300" height="auto" />
</div>
